import Vue from "vue";
import Router from "vue-router";
import constantRouterMap from "./router";
Vue.use(Router);

//解决多次点击NavigationDuplicated导航重复错误
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const router = new Router({
  mode: "hash",
  routes: constantRouterMap,
  // 滚动行为，
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    // return {x:0,y:0}
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

export default router;
